import { api } from '../config'

export const NOTIFICATIONS_URL = {
  sendNotification: `${api.withAPI}user/api/v1/admin/notification/all`,
}
